import React, { useContext } from 'react';
import { SiteContext } from '../../contexts/SiteContext';

export default function CookiePolicy({t}) {
  const { website } = useContext(SiteContext);

  const SITE = website?.title || t('legal.cookies.fallbackSite', { defaultValue: 'Your Website' });
  const UPDATED = '2025-10-08';

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('legal.cookies.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">
        {t('legal.cookies.lastUpdated', { date: UPDATED })}
      </p>

      <p className="mb-6">
        {t('legal.cookies.intro', { site: SITE })}
      </p>

      <section className="space-y-5">
        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.cookies.what.title')}</h2>
          <p>{t('legal.cookies.what.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.cookies.categories.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <strong>{t('legal.cookies.categories.items.strict')}</strong>{' '}
              {t('legal.cookies.categories.desc.strict')}
            </li>
            <li>
              <strong>{t('legal.cookies.categories.items.prefs')}</strong>{' '}
              {t('legal.cookies.categories.desc.prefs')}
            </li>
            <li>
              <strong>{t('legal.cookies.categories.items.analytics')}</strong>{' '}
              {t('legal.cookies.categories.desc.analytics')}
            </li>
            <li>
              <strong>{t('legal.cookies.categories.items.media')}</strong>{' '}
              {t('legal.cookies.categories.desc.media')}
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.cookies.manage.title')}</h2>
          <p className="mb-3">{t('legal.cookies.manage.body')}</p>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent('cookie:open'))}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            {t('legal.cookies.manage.open')}
          </button>
        </div>
      </section>
    </div>
  );
}
